import { useFetchData } from "../../../hooks/useFetch";
import { BaseResponse } from "../../../models/response/base-response";
import {
  ApiConfig,
  API_SERVICE_ADDON_ROUTER,
} from "../../../services/api-config";

/**
 * Định nghĩa interface Addon
 */
export interface Addon {
  id: number;
  name: string;
  price: number;
  status?: number;
  branch_id?: number;
  store_id?: number;
  description?: string;
}

/**
 * Response chuẩn từ API
 */
export interface AddonListResponse {
  list: Addon[];
  total_record: number;
  limit?: number;
}
export interface AddonListFilters {
  status?: number;
  branch_id?: number;
  store_id?: number;
}

export const ServiceAddonService = {
  listActive: () => {
    const { request, baseResponse, loading } =
      useFetchData.Get<AddonListResponse>({
        projectId: ApiConfig.PROJECT_ID.PRODUCT_SERVICE,
      });

    /**
     * Fetch toàn bộ dịch vụ thêm (status = 1)
     * Có thể truyền branch_id và store_id từ POS
     */
    const fetch = async (
      params: AddonListFilters = { status: 1 }
    ): Promise<BaseResponse<AddonListResponse> | undefined> => {
      return request({
        endPoint: API_SERVICE_ADDON_ROUTER.API_LIST,
        data: params,
      });
    };

    return { fetch, response: baseResponse, loading };
  },
};
export default ServiceAddonService;
